import socket from './socket';

/* Actions */

const createLabel = (groupId, data, headers) =>
  socket.post(`/groups/${groupId}/labels`, data, headers);

const updateLabel = (id, data, headers) => socket.patch(`/labels/${id}`, data, headers);

const deleteLabel = (id, headers) => socket.delete(`/labels/${id}`, undefined, headers);

export default {
  createLabel,
  updateLabel,
  deleteLabel,
};
